// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3XgWP","error":"Textarea_error__SMpX_","readonly":"Textarea_readonly__2NwlG","disabled":"Textarea_disabled__KKiJE"};